import { IkasStockLocationAddress } from "./address";

export type IkasStockLocation = {
  address: IkasStockLocationAddress | null;
  deliveryTime: IkasStockLocationDeliveryTime | null;
  description: string | null;
  isRemindOutOfStockEnabled: boolean | null;
  name: string;
  outOfStockMailList: string[] | null;
  type: IkasStockLocationType | null;
  id: string;
};

export enum IkasStockLocationDeliveryTime {
  TWO_IN_FOUR_DAYS = "TWO_IN_FOUR_DAYS",
  WITHIN_FOUR_HOURS = "WITHIN_FOUR_HOURS",
  WITHIN_ONE_HOUR = "WITHIN_ONE_HOUR",
  WITHIN_PLUS_FIVE_DAYS = "WITHIN_PLUS_FIVE_DAYS",
  WITHIN_TWENTY_FOUR_HOURS = "WITHIN_TWENTY_FOUR_HOURS",
  WITHIN_TWO_HOURS = "WITHIN_TWO_HOURS",
}

export enum IkasStockLocationType {
  PHYSICAL = "PHYSICAL",
  VIRTUAL = "VIRTUAL",
}
